import { observable, action } from 'mobx';
import { SHOP_LOCALE } from './constants';

const DEFAULT_LANGUAGE_CODE = 'en';
const localstoragekeyname = 'alo-users-preferred-language';

const normalizeLanguageCode = (languageCode: string | undefined | null) => {
  const normalizedLanguageCode = languageCode?.trim().toLowerCase().replace(/_/g, '-');
  return normalizedLanguageCode && /^[a-z]{2,3}(?:-[a-z0-9]{2,8})?$/.test(normalizedLanguageCode)
    ? normalizedLanguageCode
    : null;
};

const getStoredPreferredLanguage = () => normalizeLanguageCode(localStorage.getItem(localstoragekeyname));

const shopifyThemeLanguageVal = normalizeLanguageCode(SHOP_LOCALE);
if (!getStoredPreferredLanguage() && shopifyThemeLanguageVal) {
  localStorage.setItem(localstoragekeyname, shopifyThemeLanguageVal);
}

export const LanguageState = observable({
  languageCode: getStoredPreferredLanguage() ?? shopifyThemeLanguageVal ?? DEFAULT_LANGUAGE_CODE,
});

export const updateLanguageCode = action(
  (languageCode: string | undefined | null, { updateUserPreference = false } = {}) => {
    const normalizedLanguageCode = normalizeLanguageCode(languageCode);
    if (!normalizedLanguageCode) return false;
    LanguageState.languageCode = normalizedLanguageCode;
    if (updateUserPreference) {
      localStorage.setItem(localstoragekeyname, normalizedLanguageCode);
    }
    return true;
  }
);

export const getUsersPreferredLanguage = getStoredPreferredLanguage;
